type TFunction = (key: string) => string;

const createLikeCountMessage = ({ t, likeCount }: { t: TFunction; likeCount?: number }) => {
  if (!likeCount) {
    return null;
  }

  return `${likeCount} ${
    likeCount > 1 ? t('like-button.total-likes_plural') : t('like-button.total-likes')
  }`;
};

const createLikedStatusMessage = ({
  t,
  isComment,
  isLiked,
}: {
  t: TFunction;
  isComment?: boolean;
  isLiked?: boolean;
}) => {
  if (isLiked) {
    return isComment ? t('like-button.comment-is-liked') : t('like-button.is-liked');
  }

  return isComment ? t('like-button.comment-is-unliked') : t('like-button.is-unliked');
};

export const createLikeButtonMessage = ({
  t,
  isLiked,
  likeCount,
  isComment,
}: {
  t: TFunction;
  isLiked?: boolean;
  likeCount?: number;
  isComment?: boolean;
}) => {
  const likesCountMessage = createLikeCountMessage({ t, likeCount });
  const likedStatusMessage = createLikedStatusMessage({
    t,
    isComment,
    isLiked,
  });

  return likesCountMessage ? `${likesCountMessage} ${likedStatusMessage}` : likedStatusMessage;
};
